require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./imperfection-is-beauty.json") })
        }
      }, "path---imperfection-is-beauty");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---imperfection-is-beauty!./.cache/json/imperfection-is-beauty.json
// module id = 835
// module chunks = 231608221292675